import React from 'react';
import PropTypes from 'prop-types';
import iconColorsMap from './colors';

const Slack = ({ fill, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="none">
      <path
        fill={fill[0]}
        d="M6.832 14.351c0 1.03-.842 1.873-1.872 1.873a1.877 1.877 0 01-1.873-1.873c0-1.03.842-1.872 1.873-1.872h1.872v1.872zm.944 0c0-1.03.842-1.872 1.872-1.872 1.031 0 1.873.841 1.873 1.872v4.689c0 1.03-.842 1.872-1.873 1.872a1.877 1.877 0 01-1.872-1.872V14.35z"
      />
      <path
        fill={fill[1]}
        d="M9.648 6.832A1.877 1.877 0 017.776 4.96c0-1.031.842-1.873 1.872-1.873 1.031 0 1.873.842 1.873 1.873v1.872H9.648zm0 .944c1.031 0 1.873.842 1.873 1.872 0 1.031-.842 1.873-1.873 1.873H4.96a1.877 1.877 0 01-1.873-1.873c0-1.03.842-1.872 1.873-1.872h4.688z"
      />
      <path
        fill={fill[2]}
        d="M17.167 9.648c0-1.03.842-1.872 1.873-1.872 1.03 0 1.872.842 1.872 1.872 0 1.031-.842 1.873-1.872 1.873h-1.873V9.648zm-.943 0c0 1.031-.842 1.873-1.873 1.873a1.877 1.877 0 01-1.872-1.873V4.96c0-1.031.841-1.873 1.872-1.873 1.03 0 1.873.842 1.873 1.873v4.688z"
      />
      <path
        fill={fill[3]}
        d="M14.351 17.167c1.03 0 1.873.842 1.873 1.873 0 1.03-.842 1.872-1.873 1.872a1.877 1.877 0 01-1.872-1.872v-1.873h1.872zm0-.943a1.877 1.877 0 01-1.872-1.873c0-1.03.841-1.872 1.872-1.872h4.689c1.03 0 1.872.841 1.872 1.872 0 1.03-.842 1.873-1.872 1.873H14.35z"
      />
    </g>
  </svg>
);
Slack.propTypes = { fill: PropTypes.array };
Slack.defaultProps = {
  fill: [
    iconColorsMap.slackred,
    iconColorsMap.slackblue,
    iconColorsMap.slackgreen,
    iconColorsMap.slackyellow,
  ],
};

export default Slack;
